import { FC } from 'react';

import { useTranslations } from '../hooks/useTranslations.ts';
import { translationKeys } from '../translations/translationKeys.ts';
import ThankYouContent from './ThankYouContent.tsx';
import ThankYouScreenWrapper, { ThankYouScreenProps } from './ThankYouScreenWrapper.tsx';

const ThankYouScreenContainerMultiAsset: FC<ThankYouScreenProps> = (props) => {
  const { translate } = useTranslations();
  const title =
    props.context === 'Live'
      ? translate(translationKeys.THANK_YOU_APPLICATION_RECEIVED_TITLE)
      : translate(translationKeys.THANK_YOU_DEMO_READY_TITLE);

  return (
    <ThankYouScreenWrapper {...props} title={title}>
      <ThankYouContent embedded={props.embedded} context={props.context} />
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenContainerMultiAsset;
